/**
 * Romania's 42 administrative units (41 județe + Bucharest municipality).
 * Stored alphabetically by name for display; ISO 3166-2:RO codes used as
 * the value persisted on the user record (e.g. "RO-CJ" for Cluj). The two
 * special București codes are kept separate so admins can filter by
 * municipality vs surrounding Ilfov county.
 */
export const RO_COUNTIES = [
  { code: "RO-AB", name: "Alba" },
  { code: "RO-AR", name: "Arad" },
  { code: "RO-AG", name: "Argeș" },
  { code: "RO-BC", name: "Bacău" },
  { code: "RO-BH", name: "Bihor" },
  { code: "RO-BN", name: "Bistrița-Năsăud" },
  { code: "RO-BT", name: "Botoșani" },
  { code: "RO-BV", name: "Brașov" },
  { code: "RO-BR", name: "Brăila" },
  { code: "RO-B", name: "București" },
  { code: "RO-BZ", name: "Buzău" },
  { code: "RO-CS", name: "Caraș-Severin" },
  { code: "RO-CL", name: "Călărași" },
  { code: "RO-CJ", name: "Cluj" },
  { code: "RO-CT", name: "Constanța" },
  { code: "RO-CV", name: "Covasna" },
  { code: "RO-DB", name: "Dâmbovița" },
  { code: "RO-DJ", name: "Dolj" },
  { code: "RO-GL", name: "Galați" },
  { code: "RO-GR", name: "Giurgiu" },
  { code: "RO-GJ", name: "Gorj" },
  { code: "RO-HR", name: "Harghita" },
  { code: "RO-HD", name: "Hunedoara" },
  { code: "RO-IL", name: "Ialomița" },
  { code: "RO-IS", name: "Iași" },
  { code: "RO-IF", name: "Ilfov" },
  { code: "RO-MM", name: "Maramureș" },
  { code: "RO-MH", name: "Mehedinți" },
  { code: "RO-MS", name: "Mureș" },
  { code: "RO-NT", name: "Neamț" },
  { code: "RO-OT", name: "Olt" },
  { code: "RO-PH", name: "Prahova" },
  { code: "RO-SJ", name: "Sălaj" },
  { code: "RO-SM", name: "Satu Mare" },
  { code: "RO-SB", name: "Sibiu" },
  { code: "RO-SV", name: "Suceava" },
  { code: "RO-TR", name: "Teleorman" },
  { code: "RO-TM", name: "Timiș" },
  { code: "RO-TL", name: "Tulcea" },
  { code: "RO-VL", name: "Vâlcea" },
  { code: "RO-VS", name: "Vaslui" },
  { code: "RO-VN", name: "Vrancea" },
];

export const RO_COUNTY_BY_CODE = Object.fromEntries(
  RO_COUNTIES.map((c) => [c.code, c.name]),
);
